module.exports = __webpack_public_path__ + "static/img/jyun_sanpo_logo.645387e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/jyun_sanpo_logo.png
// module id = IQlj
// module chunks = 0